function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProductLifecycle = function SvgProductLifecycle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 61,
    height: 62,
    overflow: "hidden",
    viewBox: "0 0 62 61",
    ref: svgRef
  }, props), React.createElement("path", {
    style: {
      fillRule: "evenodd",
      stroke: "#002060",
      strokeOpacity: 1,
      fill: "#ebeef2",
      fillOpacity: 1
    },
    strokeMiterlimit: 8,
    stroke: "#5f6321",
    fill: "#81842d",
    d: "m 0.5,31 c 0,-16.845 13.432,-30.5 30,-30.5 16.569,0 30,13.655 30,30.5 0,16.845 -13.431,30.5 -30,30.5 -16.568,0 -30,-13.655 -30,-30.5 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 34.861,17.408682 0.09,0.143 c 0.908,0.971 2.163,1.571 3.549,1.571 1.386,0 2.641,-0.6 3.549,-1.571 l 0.09,-0.143 0.737,0.159 c 2.13,0.962 3.624,3.216 3.624,5.842 v 5.315 l -2.594,1.007 c -1.753,0.446 -3.566,0.677 -5.406,0.677 -1.84,0 -3.653,-0.231 -5.406,-0.677 l -2.594,-1.007 v -5.315 c 0,-2.626 1.495,-4.88 3.625,-5.842 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 33.501,14.408682 c 0,-2.761 2.239,-5.0000002 5,-5.0000002 2.761,0 5,2.2390002 5,5.0000002 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 18.861,17.408682 0.09,0.143 c 0.908,0.971 2.163,1.571 3.549,1.571 1.386,0 2.641,-0.6 3.549,-1.571 l 0.09,-0.143 0.737,0.159 c 2.13,0.962 3.624,3.216 3.624,5.842 v 5.315 l -2.594,1.007 c -1.753,0.446 -3.566,0.677 -5.406,0.677 -1.84,0 -3.653,-0.231 -5.406,-0.677 l -2.594,-1.007 v -5.315 c 0,-2.626 1.495,-4.88 3.625,-5.842 z"
  }), React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 17.501,14.408682 c 0,-2.761 2.239,-5.0000002 5,-5.0000002 2.761,0 5,2.2390002 5,5.0000002 0,2.761 -2.239,5 -5,5 -2.761,0 -5,-2.239 -5,-5 z"
  }), React.createElement("path", {
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 26.411,14.168758 0.102,0.154 c 1.021,1.045 2.433,1.692 3.992,1.692 1.559,0 2.971,-0.647 3.993,-1.692 l 0.101,-0.154 0.829,0.171 c 2.396,1.037 4.077,3.463 4.077,6.292 v 5.724 l -2.918,1.084 c -1.973,0.48 -4.012,0.729 -6.082,0.729 -2.07,0 -4.109,-0.249 -6.082,-0.729 l -2.918,-1.084 v -5.724 c 0,-2.829 1.681,-5.255 4.078,-6.292 z"
  }), React.createElement("path", {
    style: {
      fill: "#adb9ca",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#002060",
      strokeWidth: 1,
      strokeMiterlimit: 8,
      strokeOpacity: 1
    },
    d: "m 24.501,10.823637 c 0,-3.037099 2.463,-5.4999998 5.5,-5.4999998 3.038,0 5.5,2.4629008 5.5,5.4999998 0,3.037101 -2.462,5.5 -5.5,5.5 -3.037,0 -5.5,-2.462899 -5.5,-5.5 z"
  }), React.createElement("path", {
    d: "m 13.770639,38.219565 c 0.72164,-8.524971 7.632885,-15.065423 15.918338,-15.065423 v 7.241841 c -4.539113,0 -8.323597,3.682292 -8.709158,8.475461 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 31.842556,21.091232 v 2.248571 l 2.608212,0.483752 c 6.528777,1.862807 11.217372,7.828739 11.217372,14.802404 h -7.027739 c 0,-3.269711 -1.88451,-6.13406 -4.672101,-7.527555 l -2.125744,-0.601338 v 2.406383 L 25.049865,26.99734 Z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "m 52.819082,21.091232 v 2.248777 l -2.738261,0.48334 c -6.854969,1.862497 -11.778303,7.828616 -11.778303,14.80261 h 7.37928 c 0,-3.269814 1.978633,-6.134586 4.905242,-7.527937 l 2.232042,-0.601369 v 2.406745 l 7.132622,-5.906057 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-primary"
  }), React.createElement("path", {
    d: "m 48.760881,40.605319 h -2.379349 l -0.512363,2.739543 C 43.898062,50.203004 37.584746,55.12923 30.204435,55.12923 v -7.383151 c 3.460777,0 6.491663,-1.979361 7.9669,-4.90766 l 0.636075,-2.2331 h -2.547388 l 6.250429,-7.136634 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "M 28.226111,58.223594 V 55.842997 L 25.488004,55.330364 C 18.633458,53.359255 13.709815,47.041596 13.709815,39.657413 h 7.37928 c 0,3.462592 1.978324,6.495068 4.905088,7.97108 l 2.231928,0.636407 v -2.547692 l 7.132892,6.252677 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#ffffff",
      fillOpacity: 1
    },
    className: "icon-secondary"
  }), React.createElement("path", {
    d: "M 24.018952,37.67832 H 21.639191 L 21.127652,34.938622 C 19.156545,28.080059 12.842868,23.154142 5.4625058,23.154142 v 7.383151 c 3.4603345,0 6.4920442,1.97967 7.9665812,4.907814 l 0.636414,2.233213 h -2.546986 l 6.250213,7.136366 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      strokeWidth: 0.999999,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#adb9ca",
      fillOpacity: 1
    },
    className: "icon-primary"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductLifecycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product-lifecycle.2137ed78.svg";
export { ForwardRef as ReactComponent };